module.exports = __webpack_public_path__ + "static/Ranger - How to Connect an Edit Only Report-1ef765db5411d88d1f699df575a326f2.pdf";